import { SYS_BREAKPOINT_MD } from '@oneaudi/unified-web-common';
import { useMediaQuery } from './use-media-query';
export function useBreakpoints() {
    const isSmallScreen = useMediaQuery(`(max-width: ${SYS_BREAKPOINT_MD})`);
    const isMediumAndUp = useMediaQuery(`(min-width: ${SYS_BREAKPOINT_MD})`);
    return {
        isSmallScreen,
        isMediumAndUp,
    };
}
